import content from "../site/content";
import { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Brand, Icon } from '../site/UI';
import { gites, gitePath, giteName } from '../site/data';
export default function NavBar() {
  const [open, setOpen] = useState(false);
  const [gitesOpen, setGitesOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
    setGitesOpen(false);
  }, [location]);
  return <header className="site-header" onKeyDown={event => {
    if (event.key === 'Escape') {
      setOpen(false);
      setGitesOpen(false);
    }
  }}>
    <div className="header-inner">
      <Brand />
      <button className="menu-toggle" aria-label={open ? content.navigation.close : content.navigation.open} aria-expanded={open} aria-controls="navigation" onClick={() => setOpen(!open)}><Icon name={open ? 'close' : 'menu'} /></button>
      <nav id="navigation" aria-label={content.navigation.mainLabel} className={open ? 'navigation is-open' : 'navigation'}>
        <NavLink to="/" end>{content.navigation.home}</NavLink>
        <div className="gites-menu" onBlur={event => {
          if (!event.currentTarget.contains(event.relatedTarget)) setGitesOpen(false);
        }}>
          <button className={location.pathname.startsWith('/hebergement') ? 'nav-button active' : 'nav-button'} aria-expanded={gitesOpen} aria-controls="gites-menu" onClick={() => setGitesOpen(!gitesOpen)}>{content.navigation.gites}{" "}<span aria-hidden="true">⌄</span></button>
          {gitesOpen && <div className="gites-dropdown" id="gites-menu"><Link to="/#nos-gites">{content.navigation.allGites}</Link>{gites.map(gite => <Link key={gite.initial} to={gitePath(gite)}>{giteName(gite)}</Link>)}</div>}
        </div>
        <NavLink to="/nos-tarifs">{content.navigation.rates}</NavLink>
        <NavLink to="/nos-videos">{content.navigation.videos}</NavLink>
        <NavLink to="/contact" className="button nav-contact">{content.navigation.contactCta}</NavLink>
      </nav>
    </div>
  </header>;
}
